const SaveFilter = (state = {}, action) => {
  switch (action.type) {
    case 'SET_SAVE_FILTER': {
      return {
        ...state,
        saveFilters: action.payload,
      };
    }
    case 'SET_SELECTED_SAVE_FILTER': {
      return {
        ...state,
        selected: action.payload || null,
      };
    }
    default: {
      return state;
    }
  }
};

export default SaveFilter;
